import { render, staticRenderFns } from "./PageComponentChrome.vue?vue&type=template&id=e7014ef0&scoped=true&"
import script from "./PageComponentChrome.vue?vue&type=script&lang=js&"
export * from "./PageComponentChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7014ef0",
  null
  
)

export default component.exports